import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useParams } from 'react-router-dom';

import { updateCourseById } from 'store/course/actions';
import { currentCourseSelector } from 'store/course/selectors';

import { getTranslation } from 'helpers/getTranslation';
import { showToast } from 'helpers/showToast';

import { convertDataToApi } from './MarketingSettings.helpers';

import MarketingSettings from './MarketingSettings';

const MarketingSettingsContainer = ({
  onClose,
  ...restProps
}: { onClose: any } & Record<string, any>) => {
  const dispatch = useAppDispatch();

  const { id: courseId } = useParams();

  const course = useAppSelector(currentCourseSelector);

  const [saveLoading, setSaveLoading] = useState(false);

  const handleSaveClick = async (data: any) => {
    try {
      await dispatch(
        updateCourseById({ courseId, data: convertDataToApi(data) }),
      ).unwrap();

      showToast({
        data: {
          variant: 'success',
          title: getTranslation('common.toast.course_saved.title'),
          text: getTranslation('common.toast.course_saved.text'),
        },
      });

      onClose();
    } catch (error) {
      showToast({
        data: {
          variant: 'error',
          title: getTranslation('common.toast.error.title'),
          text: getTranslation('common.toast.error.text'),
        },
      });
    }

    setSaveLoading(false);
  };

  return (
    <MarketingSettings
      {...restProps}
      saveLoading={saveLoading}
      course={course}
      onClose={onClose}
      onSaveClick={handleSaveClick}
    />
  );
};

export default React.memo(MarketingSettingsContainer) as any;
